import React from "react";
import {Dialog} from "@mui/material";
import {observer} from "mobx-react";
import './modal.scss'
import {MissingDetailsStep} from "../OnBoarding/SharedSteps";
import {useStores} from "../../Hooks";

const RequireUserDetailsModal = observer(() => {
    const {generalStore} = useStores();

    const isOpen = generalStore.userDetails && generalStore.userDetails.IsMissingDetails;

    return (
        <Dialog
            open={!!isOpen}
            className='dialog missing-details-dialog'
        >
            <MissingDetailsStep/>
        </Dialog>
    )
});

export default RequireUserDetailsModal;
